import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import axios from "axios";
import {
  disableScreenshots,
  disableInspect,
  detectDevTools,
} from "./SecurityControls";
// Import components
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Logout from "./components/Logout";
import Register from "./components/Register";
import Login from "./components/Login";
import Profile from "./components/Profile";
import Customers from "./components/Customers";
import More from "./components/More";
import Vehicles from "./components/vehicles";
import AddCustomerVehicle from "./components/AddCustomerVehicle";
import Terms from "./components/terms";
import Privacy from "./components/privacy";
import AboutUs from "./components/aboutus";
import Addjobcart from "./components/Addjobcart";
import EditCustomer from "./components/EditCustomer";
import EditVehicle from "./components/EditVehicle";
import History from "./components/history";
import JobCardDetails from "./components/JobCardDetails";
import EstimatePage from "./components/EstimatePage";
import VehicleSearchPage from "./components/VehicleSearchPage";
import ScrollToTop from "./components/ScrollToTop";
import NotificationHandler from "./components/NotificationHandler";
import FCMDebug from "./components/FCMDebug";
import Suggestion from "./components/suggestions";
import "./App.css";
import Garageterms from "./components/garageterms";
import PackageList from "./components/packageList";
import Membership from "./components/membership";
import { TokenRetryManager } from "./utils/tokenRetry";
import InsuranceList from "./components/insuranceList";
import AddInsurance from "./components/AddInsurance";
import LogoutApp from "./components/LogoutApp";
import AddServiceReminder from "./components/AddServiceReminder";
import ServiceReminderList from "./components/serviceReminderList";
import VendorList from "./components/VendorList";
import AddVendor from "./components/AddVendor";
import VendorTransactions from "./components/VendorTransactions";
import AddVendorTransaction from "./components/AddVendorTransaction";
import EditVendorTransaction from "./components/EditVendorTransaction";
import PurchaseList from "./components/PurchaseList";
import PurchaseDetails from "./components/PurchaseDetails";
import AddEditPurchase from "./components/AddEditPurchase";
import TransactionList from "./components/TransactionList";
import AddTransaction from "./components/AddTransaction";
import TransactionDashboard from "./components/transactionDashboard";

// ------------------------
// INITIAL LOCAL STORAGE SETUP
// ------------------------
localStorage.setItem("version_code", "1.0");
localStorage.setItem("company_id", "2");
localStorage.setItem("back_url", "");
localStorage.setItem("server_folder", "");

// ============================================
// Local
// ============================================
// const server_folder = localStorage.getItem("server_folder") || "";
// localStorage.setItem("server_url", server_folder + "/garage/v1/");
/* <IfModule mod_rewrite.c>
    RewriteEngine On RewriteBase / RewriteRule ^index\.html$ - [L] RewriteCond %{REQUEST_FILENAME} !-f RewriteCond %{REQUEST_FILENAME} !-d RewriteCond %{REQUEST_FILENAME} !-l RewriteRule . /index.html [L]
</IfModule>
"proxy": "http://192.168.1.222/", */

// ============================================
// Live
// ============================================
localStorage.setItem("server_folder", "/build_v1");
let server_folder = localStorage.getItem("server_folder");
localStorage.setItem("back_url", server_folder);
localStorage.setItem("server_url", server_folder + "/../v1/");
// "homepage": "https://mydigigarage.com/build_v1/",
  /* <IfModule mod_rewrite.c>
  RewriteEngine On
  
  # Handle Authorization Header
  RewriteCond %{HTTP:Authorization} .
  RewriteRule .* - [E=HTTP_AUTHORIZATION:%{HTTP:Authorization}]
  
  # Handle CORS Preflight
  RewriteCond %{REQUEST_METHOD} OPTIONS
  RewriteRule ^(.*)$ $1 [R=200,L,E=HTTP_ORIGIN:%{HTTP:ORIGIN}]
  
  # Redirect all requests to index.html
  RewriteCond %{REQUEST_FILENAME} !-f
  RewriteCond %{REQUEST_FILENAME} !-d
  RewriteRule ^(.*)$ index.html [QSA,L]
</IfModule>

# Enable CORS
<IfModule mod_headers.c>
    Header set Access-Control-Allow-Origin "*"
    Header set Access-Control-Allow-Methods "GET, POST, PUT, DELETE, OPTIONS"
    Header set Access-Control-Allow-Headers "Origin, X-Requested-With, Content-Type, Accept, Authorization"
    Header set Access-Control-Allow-Credentials "true"
</IfModule>

# Security Headers
<IfModule mod_headers.c>
    Header set X-Content-Type-Options "nosniff"
    Header set X-Frame-Options "SAMEORIGIN"
    Header set X-XSS-Protection "1; mode=block"
    
    # Service Worker specific
    <Files "firebase-messaging-sw.js">
        Header set Service-Worker-Allowed "/"
        Header set Content-Type "application/javascript; charset=UTF-8"
        Header set Cache-Control "no-cache, no-store, must-revalidate"
    </Files>
</IfModule> */
const server_url = localStorage.getItem("server_url");

// ============================================
// LAYOUT COMPONENT (FOR WRAPPING PAGES)
// ============================================
const Layout = ({ children }) => {
  const location = useLocation();

  // Pages that should show footer
  const showFooter = ["/", "/home", "/profile", "/more", "/search"].includes(
    location.pathname
  );

  return (
    <div className="default">
      <Sidebar />
      <Header />

      {/* Main content with dynamic padding for footer */}
      <div
        id="content"
        style={{
          width: "100%",
          minHeight: "calc(100vh - 55px)",
          padding: showFooter ? "55px 0px 70px" : "55px 0px 0px",
          transition: "all 0.3s",
        }}
      >
        <div className="content-wrap">{children}</div>
      </div>

      {/* Show footer only on specific pages */}
      {showFooter && <Footer />}

      {/* Overlay for sidebar */}
      <div className="overlay"></div>
    </div>
  );
};

// ============================================
// BRANDING/MARKETING PAGE FOR RIGHT SIDE
// ============================================
const BrandingPage = () => {
  return (
    <div className="branding-container">
      <div className="branding-content">
        {/* Main Header */}
        <div className="branding-header">
          <div className="branding-logo">
            <h1>Garage Management</h1>
          </div>
          <p className="branding-subtitle">Complete Garage Solution</p>
          <p className="branding-description">
            Simplify your garage operations with our all-in-one app. Manage
            customers, services, billing, and payments efficiently from your
            mobile.
          </p>

          <div className="cta-buttons">
            <button className="branding-cta primary">Download App Now</button>
          </div>

          <div className="demo-stats">
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">Garages Using</span>
            </div>
            <div className="stat">
              <span className="stat-number">4.8★</span>
              <span className="stat-label">Rating</span>
            </div>
            <div className="stat">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support</span>
            </div>
          </div>
        </div>

        {/* Features Section */}
      </div>
    </div>
  );
};

// ============================================
// ROUTE CONFIGURATIONS (Defined once)
// ============================================
const RouteDefinitions = () => {
  return (
    <Routes>
      {/* Public routes (no Layout) */}
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/LogoutApp/:id" element={<LogoutApp />} />
      <Route path="/debug" element={<FCMDebug />} />

      {/* Protected routes (with Layout) */}
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/home" element={<Layout><Home /></Layout>} />
      <Route path="/home/:id" element={<Layout><Home /></Layout>} />
      <Route path="/suggestions" element={<Layout><Suggestion /></Layout>} />
      <Route path="/profile" element={<Layout><Profile /></Layout>} />
      <Route path="/customers" element={<Layout><Customers /></Layout>} />
      <Route path="/Addjobcart" element={<Layout><Addjobcart /></Layout>} />
      <Route path="/add-customer-vehicle" element={<Layout><AddCustomerVehicle /></Layout>} />
      <Route path="/edit-customer" element={<Layout><EditCustomer /></Layout>} />
      <Route path="/edit-vehicle" element={<Layout><EditVehicle /></Layout>} />
      <Route path="/history" element={<Layout><History /></Layout>} />
      <Route path="/job-card-details/:id" element={<Layout><JobCardDetails /></Layout>} />
      <Route path="/search" element={<Layout><VehicleSearchPage /></Layout>} />
      <Route path="/vehicles" element={<Layout><Vehicles /></Layout>} />
      <Route path="/more" element={<Layout><More /></Layout>} />
      <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
      <Route path="/terms" element={<Layout><Terms /></Layout>} />
      <Route path="/about-us" element={<Layout><AboutUs /></Layout>} />
      
      <Route path="/PackageList" element={<Layout><PackageList /></Layout>} />
      <Route path="/garageterms" element={<Layout><Garageterms /></Layout>} />
      <Route path="/membership" element={<Layout><Membership /></Layout>} />
      
      <Route path="/serviceReminderList" element={<Layout><ServiceReminderList /></Layout>} />
      <Route path="/add-service-reminder" element={<Layout><AddServiceReminder /></Layout>} />
      <Route path="/edit-service-reminder" element={<Layout><AddServiceReminder /></Layout>} />
      
      <Route path="/insurance" element={<Layout><InsuranceList /></Layout>} />
      <Route path="/add-insurance" element={<Layout><AddInsurance /></Layout>} />
      <Route path="/edit-insurance" element={<Layout><AddInsurance /></Layout>} />
      
      <Route path="/vendors" element={<Layout><VendorList /></Layout>} />
      <Route path="/add-vendor" element={<Layout><AddVendor /></Layout>} />
      <Route path="/edit-vendor" element={<Layout><AddVendor /></Layout>} />
      <Route path="/vendor-transactions" element={<Layout><VendorTransactions /></Layout>} />
      <Route path="/add-vendor-transaction" element={<Layout><AddVendorTransaction /></Layout>} />
      <Route path="/edit-vendor-transaction" element={<Layout><EditVendorTransaction /></Layout>} />
      
      <Route path="/purchases" element={<Layout><PurchaseList /></Layout>} />
      <Route path="/purchase-details/:id" element={<Layout><PurchaseDetails /></Layout>} />
      <Route path="/add-purchase" element={<Layout><AddEditPurchase /></Layout>} />
      <Route path="/edit-purchase/:id" element={<Layout><AddEditPurchase /></Layout>} />
      
      <Route path="/transaction" element={<Layout><TransactionList /></Layout>} />
      <Route path="/add-transaction" element={<Layout><AddTransaction /></Layout>} />
      <Route path="/edit-transaction" element={<Layout><AddTransaction /></Layout>} />
      <Route path="/transaction-dashboard" element={<Layout><TransactionDashboard /></Layout>} />
      
      {/* Estimate page - standalone without layout */}
      <Route path="/estimate/:id" element={<EstimatePage />} />
      
      {/* 404 Page */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

// ============================================
// APP CONTENT COMPONENT (Contains all the routing logic)
// ============================================
const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // Check if current path is an estimate page
  const isEstimatePage = location.pathname.startsWith("/estimate/");

  // Handle window resize - only for non-estimate pages
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    if (!isEstimatePage) {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [isEstimatePage]);

  // Load company details
  useEffect(() => {
    const loadCompanyDetails = async () => {
      try {
        const company_id = localStorage.getItem("company_id");
        const form = new FormData();
        form.append("company_id", company_id);
        form.append("garage_id", "");
        form.append("version_code", "1.0");

        const response = await axios.post(`${server_url}check_user.php`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const company = response.data.company_details?.[0];
        if (!company) {
          setIsLoading(false);
          return;
        }

        // Store company details in localStorage
        localStorage.setItem("company_store_name", company.company_store_name);
        localStorage.setItem("company_favicon", company.company_favicon);
        localStorage.setItem(
          "company_footer_logo",
          company.company_footer_logo
        );
        localStorage.setItem(
          "company_header_logo",
          company.company_header_logo
        );
        localStorage.setItem("company_email", company.company_email);
        localStorage.setItem("company_mobile", company.company_mobile);
        localStorage.setItem("company_landline", company.company_landline);
        localStorage.setItem("company_address", company.company_address);
        localStorage.setItem(
          "company_terms_and_condition",
          company.company_terms_and_condition
        );
        localStorage.setItem(
          "company_privacy_policy",
          company.company_privacy_policy
        );
        localStorage.setItem("company_about_us", company.company_about_us);
        localStorage.setItem("company_website", company.company_website);
      } catch (err) {
        console.error("check_user API error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    // Only load if not already loaded
    if (!localStorage.getItem("company_header_logo")) {
      loadCompanyDetails();
    } else {
      setIsLoading(false);
    }
  }, []);

  // Loading state
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // ============================================
  // ESTIMATE PAGE VIEW (ALWAYS MOBILE VIEW)
  // ============================================
  if (isEstimatePage) {
    return (
      <>
        <ScrollToTop />
        <NotificationHandler />
        <Toaster position="bottom-right" toastOptions={{ duration: 4000 }} />

        <div className="mobile-app estimate-page-view">
          <RouteDefinitions />
        </div>
      </>
    );
  }

  // ============================================
  // MOBILE VIEW (ACTUAL MOBILE DEVICES) - For non-estimate pages
  // ============================================
  if (isMobile) {
    return (
      <>
        <ScrollToTop />
        <NotificationHandler />
        <Toaster position="bottom-right" toastOptions={{ duration: 4000 }} />

        <div className="mobile-app">
          <RouteDefinitions />
        </div>
      </>
    );
  }

  // ============================================
  // DESKTOP VIEW (WITH MOBILE PREVIEW + BRANDING) - For non-estimate pages
  // ============================================
  return (
    <div className="desktop-container">
      {/* LEFT SIDE: Mobile Phone Preview */}
      <div className="mobile-preview">
        <div className="mobile-frame">
          <div className="mobile-screen">
            <NotificationHandler />
            <Toaster
              position="bottom-right"
              toastOptions={{ duration: 4000 }}
            />

            {/* This is where your actual app runs inside the phone frame */}
            <div className="mobile-app-content">
              <RouteDefinitions />
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE: Marketing/Branding Content */}
      <BrandingPage />
    </div>
  );
};

// ============================================
// MAIN APP COMPONENT (Wrapper with Router)
// ============================================
function App() {
  useEffect(() => {
    // disableScreenshots(true);  // ON / OFF
    // disableInspect(true);      // ON / OFF
    // detectDevTools(true);      // ON / OFF
  }, []);

  useEffect(() => {
    // Try to get FCM token on app load if user is logged in
    const garageId = localStorage.getItem("grage_id");
    const companyId = localStorage.getItem("company_id");

    if (garageId && companyId) {
      // Retry token in background
      setTimeout(() => {
        TokenRetryManager.retryIfNeeded(garageId, companyId).then((token) => {
          if (token) {
            // Send token to server via check_user
            const server_url = localStorage.getItem("server_url");
            const form = new FormData();
            form.append("company_id", companyId);
            form.append("garage_id", garageId);
            form.append("version_code", "1.0");
            form.append("web_token", token);

            axios
              .post(`${server_url}check_user.php`, form, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .catch((err) => {
                console.error("Error sending token to server:", err);
              });
          }
        });
      }, 2000);
    }
  }, []);

  return (
    <div style={{ backgroundColor: "#00409e" }}>
      <BrowserRouter basename={server_folder}>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;